import {observer} from "mobx-react";
import {Linq, ScrollTable} from "../../ui";
import {stsOverviewStore} from "../../../store";
import {convertStsStatus, exportStsReason} from "../../../api";
import {useNavigate} from "react-router";

const StsOverviewList = observer(function StsOverviewList() {
    const navigate = useNavigate()
    return <>
        <ScrollTable>
            <thead>
            <tr>
                <th>Kunde</th>
                <th>Fahrzeug</th>
                <th>Grund</th>
                <th>Status</th>
            </tr>
            </thead>
            <tbody>
            {stsOverviewStore.items.map((val, index) => {
                const link = `/sts/${val.id}`
                return <tr key={index} onClick={(e) => {
                    e.preventDefault()
                    navigate(link
                    )
                }}>
                    <td><Linq to={`${link}`}>{val.customer || val.customerId}</Linq></td>
                    <td><Linq to={`${link}`}>{val.vin}</Linq></td>
                    <td><Linq to={`${link}`}>{exportStsReason(val.reason)}</Linq></td>
                    <td><Linq to={`${link}`}>{convertStsStatus(val.status)}</Linq></td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
    </>
})

export {
    StsOverviewList
}
